// extracted by mini-css-extract-plugin
var _1 = "mYaQL__boxShadow";
var _2 = "mYaQL__button";
var _3 = "mYaQL__coin";
var _4 = "mYaQL__coin_lost";
var _5 = "mYaQL__coin_selected";
var _6 = "mYaQL__coin_won";
var _7 = "mYaQL__coins";
export { _1 as "boxShadow", _2 as "button", _3 as "coin", _4 as "coin_lost", _5 as "coin_selected", _6 as "coin_won", _7 as "coins" }
